/**
 * Base API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MenuConfigEntry { 
    type?: MenuConfigEntry.TypeEnum;
    element?: MenuConfigEntry.ElementEnum;
    parent?: MenuConfigEntry.ParentEnum;
    orderIndex?: number;
    deactivated?: boolean;
}
export namespace MenuConfigEntry {
    export type TypeEnum = 'MENU' | 'PUBLIC';
    export const TypeEnum = {
        MENU: 'MENU' as TypeEnum,
        PUBLIC: 'PUBLIC' as TypeEnum
    };
    export type ElementEnum = 'MENU_ROOT' | 'HOME' | 'POSTFACH' | 'RECHNUNGEN_GEBUEHREN' | 'GRUNDSTUECK' | 'GRUNDBUCH' | 'GRUNDBUCHGESCHAEFTE' | 'AUFGABEN_PENDENZEN' | 'EGVT' | 'RECHTE' | 'BERECHTIGTE_PERSONEN' | 'GRUNDBUCHMELDUNG' | 'ALTE_GRUNDBUCHMELDUNGEN' | 'ECH_0134_GRUNDBUCHMELDUNGEN' | 'PUBLIKATION' | 'TITELKONTROLLE' | 'VERMESSUNG' | 'ERWEITERTES_SUCHREGISTER' | 'GEOMETERGESCHAEFT' | 'GEBAEUDE' | 'AVGBS_AV_MUTATION' | 'AVGBS_GRUNDSTUECKBESCHRIEB' | 'NOTARIAT' | 'GEBAEUDE_UND_WOHNUNGSREGISTER' | 'GWR_GEBAEUDE' | 'GWR_BAUPROJEKTE' | 'AMTLICHE_BEWERTUNG' | 'NESKOAB' | 'STAMMDATEN' | 'STAMMPERSONEN' | 'ORGANISATORISCHE_EINHEITEN' | 'POLITISCHE_GEMEINDEN' | 'GEMEINDE_GEMEINDEKREIS' | 'CODES' | 'SYSTEM' | 'AUSWERTUNGEN' | 'EIGENTUEMERADRESSLISTE' | 'IMPORT_EXPORT' | 'KONFIGURATION' | 'ECH_0134_EMPFAENGER' | 'UNTERSTUETZUNG' | 'PARAMETER' | 'FREMDSYSTEM' | 'E_PRAEFIXE' | 'MELDUNGSEMPFAENGER' | 'HOME_PUBLIC' | 'MEINE_GRUNDSTUECKE_PUBLIC' | 'UNTERSTUETZUNG_PUBLIC';
    export const ElementEnum = {
        MENU_ROOT: 'MENU_ROOT' as ElementEnum,
        HOME: 'HOME' as ElementEnum,
        POSTFACH: 'POSTFACH' as ElementEnum,
        RECHNUNGEN_GEBUEHREN: 'RECHNUNGEN_GEBUEHREN' as ElementEnum,
        GRUNDSTUECK: 'GRUNDSTUECK' as ElementEnum,
        GRUNDBUCH: 'GRUNDBUCH' as ElementEnum,
        GRUNDBUCHGESCHAEFTE: 'GRUNDBUCHGESCHAEFTE' as ElementEnum,
        AUFGABEN_PENDENZEN: 'AUFGABEN_PENDENZEN' as ElementEnum,
        EGVT: 'EGVT' as ElementEnum,
        RECHTE: 'RECHTE' as ElementEnum,
        BERECHTIGTE_PERSONEN: 'BERECHTIGTE_PERSONEN' as ElementEnum,
        GRUNDBUCHMELDUNG: 'GRUNDBUCHMELDUNG' as ElementEnum,
        ALTE_GRUNDBUCHMELDUNGEN: 'ALTE_GRUNDBUCHMELDUNGEN' as ElementEnum,
        ECH_0134_GRUNDBUCHMELDUNGEN: 'ECH_0134_GRUNDBUCHMELDUNGEN' as ElementEnum,
        PUBLIKATION: 'PUBLIKATION' as ElementEnum,
        TITELKONTROLLE: 'TITELKONTROLLE' as ElementEnum,
        VERMESSUNG: 'VERMESSUNG' as ElementEnum,
        ERWEITERTES_SUCHREGISTER: 'ERWEITERTES_SUCHREGISTER' as ElementEnum,
        GEOMETERGESCHAEFT: 'GEOMETERGESCHAEFT' as ElementEnum,
        GEBAEUDE: 'GEBAEUDE' as ElementEnum,
        AVGBS_AV_MUTATION: 'AVGBS_AV_MUTATION' as ElementEnum,
        AVGBS_GRUNDSTUECKBESCHRIEB: 'AVGBS_GRUNDSTUECKBESCHRIEB' as ElementEnum,
        NOTARIAT: 'NOTARIAT' as ElementEnum,
        GEBAEUDE_UND_WOHNUNGSREGISTER: 'GEBAEUDE_UND_WOHNUNGSREGISTER' as ElementEnum,
        GWR_GEBAEUDE: 'GWR_GEBAEUDE' as ElementEnum,
        GWR_BAUPROJEKTE: 'GWR_BAUPROJEKTE' as ElementEnum,
        AMTLICHE_BEWERTUNG: 'AMTLICHE_BEWERTUNG' as ElementEnum,
        NESKOAB: 'NESKOAB' as ElementEnum,
        STAMMDATEN: 'STAMMDATEN' as ElementEnum,
        STAMMPERSONEN: 'STAMMPERSONEN' as ElementEnum,
        ORGANISATORISCHE_EINHEITEN: 'ORGANISATORISCHE_EINHEITEN' as ElementEnum,
        POLITISCHE_GEMEINDEN: 'POLITISCHE_GEMEINDEN' as ElementEnum,
        GEMEINDE_GEMEINDEKREIS: 'GEMEINDE_GEMEINDEKREIS' as ElementEnum,
        CODES: 'CODES' as ElementEnum,
        SYSTEM: 'SYSTEM' as ElementEnum,
        AUSWERTUNGEN: 'AUSWERTUNGEN' as ElementEnum,
        EIGENTUEMERADRESSLISTE: 'EIGENTUEMERADRESSLISTE' as ElementEnum,
        IMPORT_EXPORT: 'IMPORT_EXPORT' as ElementEnum,
        KONFIGURATION: 'KONFIGURATION' as ElementEnum,
        ECH_0134_EMPFAENGER: 'ECH_0134_EMPFAENGER' as ElementEnum,
        UNTERSTUETZUNG: 'UNTERSTUETZUNG' as ElementEnum,
        PARAMETER: 'PARAMETER' as ElementEnum,
        FREMDSYSTEM: 'FREMDSYSTEM' as ElementEnum,
        E_PRAEFIXE: 'E_PRAEFIXE' as ElementEnum,
        MELDUNGSEMPFAENGER: 'MELDUNGSEMPFAENGER' as ElementEnum,
        HOME_PUBLIC: 'HOME_PUBLIC' as ElementEnum,
        MEINE_GRUNDSTUECKE_PUBLIC: 'MEINE_GRUNDSTUECKE_PUBLIC' as ElementEnum,
        UNTERSTUETZUNG_PUBLIC: 'UNTERSTUETZUNG_PUBLIC' as ElementEnum
    };
    export type ParentEnum = 'MENU_ROOT' | 'HOME' | 'POSTFACH' | 'RECHNUNGEN_GEBUEHREN' | 'GRUNDSTUECK' | 'GRUNDBUCH' | 'GRUNDBUCHGESCHAEFTE' | 'AUFGABEN_PENDENZEN' | 'EGVT' | 'RECHTE' | 'BERECHTIGTE_PERSONEN' | 'GRUNDBUCHMELDUNG' | 'ALTE_GRUNDBUCHMELDUNGEN' | 'ECH_0134_GRUNDBUCHMELDUNGEN' | 'PUBLIKATION' | 'TITELKONTROLLE' | 'VERMESSUNG' | 'ERWEITERTES_SUCHREGISTER' | 'GEOMETERGESCHAEFT' | 'GEBAEUDE' | 'AVGBS_AV_MUTATION' | 'AVGBS_GRUNDSTUECKBESCHRIEB' | 'NOTARIAT' | 'GEBAEUDE_UND_WOHNUNGSREGISTER' | 'GWR_GEBAEUDE' | 'GWR_BAUPROJEKTE' | 'AMTLICHE_BEWERTUNG' | 'NESKOAB' | 'STAMMDATEN' | 'STAMMPERSONEN' | 'ORGANISATORISCHE_EINHEITEN' | 'POLITISCHE_GEMEINDEN' | 'GEMEINDE_GEMEINDEKREIS' | 'CODES' | 'SYSTEM' | 'AUSWERTUNGEN' | 'EIGENTUEMERADRESSLISTE' | 'IMPORT_EXPORT' | 'KONFIGURATION' | 'ECH_0134_EMPFAENGER' | 'UNTERSTUETZUNG' | 'PARAMETER' | 'FREMDSYSTEM' | 'E_PRAEFIXE' | 'MELDUNGSEMPFAENGER' | 'HOME_PUBLIC' | 'MEINE_GRUNDSTUECKE_PUBLIC' | 'UNTERSTUETZUNG_PUBLIC';
    export const ParentEnum = {
        MENU_ROOT: 'MENU_ROOT' as ParentEnum,
        HOME: 'HOME' as ParentEnum,
        POSTFACH: 'POSTFACH' as ParentEnum,
        RECHNUNGEN_GEBUEHREN: 'RECHNUNGEN_GEBUEHREN' as ParentEnum,
        GRUNDSTUECK: 'GRUNDSTUECK' as ParentEnum,
        GRUNDBUCH: 'GRUNDBUCH' as ParentEnum,
        GRUNDBUCHGESCHAEFTE: 'GRUNDBUCHGESCHAEFTE' as ParentEnum,
        AUFGABEN_PENDENZEN: 'AUFGABEN_PENDENZEN' as ParentEnum,
        EGVT: 'EGVT' as ParentEnum,
        RECHTE: 'RECHTE' as ParentEnum,
        BERECHTIGTE_PERSONEN: 'BERECHTIGTE_PERSONEN' as ParentEnum,
        GRUNDBUCHMELDUNG: 'GRUNDBUCHMELDUNG' as ParentEnum,
        ALTE_GRUNDBUCHMELDUNGEN: 'ALTE_GRUNDBUCHMELDUNGEN' as ParentEnum,
        ECH_0134_GRUNDBUCHMELDUNGEN: 'ECH_0134_GRUNDBUCHMELDUNGEN' as ParentEnum,
        PUBLIKATION: 'PUBLIKATION' as ParentEnum,
        TITELKONTROLLE: 'TITELKONTROLLE' as ParentEnum,
        VERMESSUNG: 'VERMESSUNG' as ParentEnum,
        ERWEITERTES_SUCHREGISTER: 'ERWEITERTES_SUCHREGISTER' as ParentEnum,
        GEOMETERGESCHAEFT: 'GEOMETERGESCHAEFT' as ParentEnum,
        GEBAEUDE: 'GEBAEUDE' as ParentEnum,
        AVGBS_AV_MUTATION: 'AVGBS_AV_MUTATION' as ParentEnum,
        AVGBS_GRUNDSTUECKBESCHRIEB: 'AVGBS_GRUNDSTUECKBESCHRIEB' as ParentEnum,
        NOTARIAT: 'NOTARIAT' as ParentEnum,
        GEBAEUDE_UND_WOHNUNGSREGISTER: 'GEBAEUDE_UND_WOHNUNGSREGISTER' as ParentEnum,
        GWR_GEBAEUDE: 'GWR_GEBAEUDE' as ParentEnum,
        GWR_BAUPROJEKTE: 'GWR_BAUPROJEKTE' as ParentEnum,
        AMTLICHE_BEWERTUNG: 'AMTLICHE_BEWERTUNG' as ParentEnum,
        NESKOAB: 'NESKOAB' as ParentEnum,
        STAMMDATEN: 'STAMMDATEN' as ParentEnum,
        STAMMPERSONEN: 'STAMMPERSONEN' as ParentEnum,
        ORGANISATORISCHE_EINHEITEN: 'ORGANISATORISCHE_EINHEITEN' as ParentEnum,
        POLITISCHE_GEMEINDEN: 'POLITISCHE_GEMEINDEN' as ParentEnum,
        GEMEINDE_GEMEINDEKREIS: 'GEMEINDE_GEMEINDEKREIS' as ParentEnum,
        CODES: 'CODES' as ParentEnum,
        SYSTEM: 'SYSTEM' as ParentEnum,
        AUSWERTUNGEN: 'AUSWERTUNGEN' as ParentEnum,
        EIGENTUEMERADRESSLISTE: 'EIGENTUEMERADRESSLISTE' as ParentEnum,
        IMPORT_EXPORT: 'IMPORT_EXPORT' as ParentEnum,
        KONFIGURATION: 'KONFIGURATION' as ParentEnum,
        ECH_0134_EMPFAENGER: 'ECH_0134_EMPFAENGER' as ParentEnum,
        UNTERSTUETZUNG: 'UNTERSTUETZUNG' as ParentEnum,
        PARAMETER: 'PARAMETER' as ParentEnum,
        FREMDSYSTEM: 'FREMDSYSTEM' as ParentEnum,
        E_PRAEFIXE: 'E_PRAEFIXE' as ParentEnum,
        MELDUNGSEMPFAENGER: 'MELDUNGSEMPFAENGER' as ParentEnum,
        HOME_PUBLIC: 'HOME_PUBLIC' as ParentEnum,
        MEINE_GRUNDSTUECKE_PUBLIC: 'MEINE_GRUNDSTUECKE_PUBLIC' as ParentEnum,
        UNTERSTUETZUNG_PUBLIC: 'UNTERSTUETZUNG_PUBLIC' as ParentEnum
    };
}


